import { Component, HostListener, Injector, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { appearance } from 'src/app/config/appearance';
import { LocaleDataService } from '../../angular-common/locale-data.service';
import { SecurityDataService } from '../../angular-common/security-data.service';
import { BaseView } from '../base-view';
import { CookiePolicyDialogComponent } from '../cookie-policy-dialog/cookie-policy-dialog.component';

@Component({
  selector: 'app-cookie-policy-footer',
  templateUrl: './cookie-policy-footer.component.html',
  styleUrls: ['./cookie-policy-footer.component.scss']
})
export class CookiePolicyFooterComponent extends BaseView {

  constructor(public securityDataService: SecurityDataService,
    protected _injector: Injector) {
    super(_injector)
  }

  @HostListener('document:click', ['$event'])
  private onClick(event) {
    if(event.target.className.split(' ').includes('show'))  
      this.showCookiePolicy()
  }

  public acceptCookiePolicy(){
    this.securityDataService.acceptCookiePolicy();
  }

  public showCookiePolicy() {
    this._injector.get(MatDialog).open(CookiePolicyDialogComponent, 
                                       { disableClose: false, 
                                         width: '800px',
                                         maxWidth: '100vw',
                                         direction: this._injector.get(LocaleDataService).direction });
  }
}
